import { Subject } from 'rxjs';
import { cardService } from './service';

export class CardStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.subject = new Subject();
    this.cards = [];
  }

  _emit() { this.subject.next(this); }

  setCards(list) { this.cards = list || []; this._emit(); }

  async getCards() {
    const res = await cardService.getCards();
    this.setCards(res.cards);
    return res;
  }

  async deleteCard(id) {
    // Оптимистично убираем карту; при ошибке откатываем и пробрасываем.
    const prev = this.cards;
    this.setCards(prev.filter((c) => c.id !== id));
    try {
      const res = await cardService.deleteCard(id);
      this.setCards(res.cards);
      // Обновляем auth-данные фоном, не задерживая вызывающего.
      this.rootStore.authStore.bootstrap().catch(() => { /* noop */ });
      return res;
    } catch (e) {
      this.setCards(prev);
      throw e;
    }
  }

  async addCard() {
    return cardService.addCard();
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/cardStore/index.js